import type { BookingFormData } from "../types";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isValidBookingEmail(email: string): boolean {
  return EMAIL_REGEX.test(
    String(email || "")
      .trim()
      .toLowerCase()
  );
}

export function isValidBookingWhatsapp(whatsapp: string): boolean {
  return String(whatsapp || "").replace(/\D/g, "").length >= 10;
}

export function getBookingContactValidationError(
  formData: BookingFormData
): string | null {
  if (!String(formData.name || "").trim()) {
    return "Preencha seu nome completo.";
  }

  if (!isValidBookingEmail(formData.email)) {
    return "Informe um e-mail válido.";
  }

  if (!isValidBookingWhatsapp(formData.whatsapp)) {
    return "Informe um WhatsApp válido.";
  }

  return null;
}

export function isBookingContactComplete(formData: BookingFormData): boolean {
  return getBookingContactValidationError(formData) === null;
}
